<template>
  <div>
    <v-help
      name="help-review-hour"
      :show="help_review_hour_modal_show"
      :data="{ option: 'Revisão de horas' }"
      profile="client"
      @onHide="help_review_hour_modal_show = false"
    />
    <v-modal
      :name="name"
      title="Revisão de horas"
      :show="show"
      @onHide="onHide"
      @onShow="onShow"
      :size="2"
    >
      <v-inner :size="3">
        <v-text v-if="data.task_status === 'accepted'"
          ><b>Solicitação resolvida!</b></v-text
        >
        <p>
          Revisão da atividade: <b>{{ data.task_description }}</b>
        </p>
        <div v-if="data.task_status !== 'accepted'">
          <v-input type="textarea" rows="5" v-model="task_comment_description">
            Informe qual a sua dúvida ou questionamento sobre apontamento de
            horas</v-input
          >
          <v-button class="primary block" @click="createTaskComment()"
            >Enviar</v-button
          >
        </div>
        <div v-if="data.comments.length > 0">
          <v-divider line :size="4" />
          <v-text class="mb-1">Mensagens</v-text>
          <v-list class="list-chat mb-3">
            <v-text tag="li" v-for="comment in data.comments">
              <v-div>{{ comment.description }}</v-div>
              <small>
                <span v-if="data.comment_from == comment.from">
                  Você
                </span>
                <span v-else-if="data.comment_from == 'client'">
                  {{ comment.vibbrante_name }}
                </span>
                <span v-else>
                  {{ comment.client_name }}
                </span>
                - {{ comment.created_at | moment('DD/MM/YYYY HH:mm') }}
              </small>
            </v-text>
          </v-list>
        </div>
        <br />
        <v-row :size="1">
          <v-col :md="6">
            <v-button
              class="block link"
              :size="2"
              @click="markResolved()"
              v-if="profile === 'client' && data.task_status !== 'accepted'"
              >Resolvido</v-button
            >
          </v-col>
          <v-col :md="6">
            <v-button class="block link" :size="2" @click="showHelp()"
              >Solicitar ajuda da Vibbra</v-button
            >
          </v-col>
        </v-row>
      </v-inner>
    </v-modal>
  </div>
</template>

<script>
import clientApi from '@/api/client';
import vibbranteApi from '@/api/vibbrante';
import HelpModal from '@/parts/modals/help';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'client',
    },
    data: {},
    subjectId: {
      default: 0,
    },
  },
  components: {
    'v-help': HelpModal,
  },
  data() {
    return {
      action_success: false,
      help_review_hour_modal_show: false,
    };
  },
  methods: {
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');

      // OK vars
      this.feedback_ok = false;
      this.bug_ok = false;
      this.money_transfer_ok = false;
      this.help_ok = false;
      this.finalized_ok = false;
    },
    showHelp() {
      this.hide();
      this.help_review_hour_modal_show = true;
    },
    markResolved() {
      clientApi
        .clientResolvedTask(this.data.task_id)
        .then(response => {
          if (response.status === 200) {
            this.task_comment_description = '';
            this.$emit('resolvedTask');
            this.hide();
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    createTaskComment() {
      if (this.data.comment_from === 'client') {
        clientApi
          .clientCreateTaskComment(
            this.data.task_id,
            this.task_comment_description
          )
          .then(response => {
            if (response.status === 200) {
              this.task_comment_description = '';
              this.$emit('createTaskComment');
              this.hide();
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        vibbranteApi
          .vibbranteCreateTaskComment(
            this.data.task_id,
            this.task_comment_description
          )
          .then(response => {
            if (response.status === 200) {
              this.task_comment_description = '';
              this.$emit('createTaskComment');
              this.hide();
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/hour-review.vue